module.exports = __webpack_public_path__ + "img/q.6d0c1711.jpg";